import { SearchGroupTagsContext } from '@trinity/chat-components';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useCallback } from 'react';

type Props = {
  children: React.ReactNode;
};

export const GroupTagsSearchContainer = (props: Props) => {

  const apiClient = useChatApiClient();

  const searchTags = useCallback((data: { query: string }) => {
    return apiClient.search.searchTags({ query: data.query });
  }, [apiClient]);

  return (
    <SearchGroupTagsContext.Provider value={searchTags}>
      {props.children}
    </SearchGroupTagsContext.Provider>
  );
};